import { render, staticRenderFns } from "./PerformanceSta.vue?vue&type=template&id=1c05d84c&scoped=true"
import script from "./PerformanceSta.vue?vue&type=script&lang=js"
export * from "./PerformanceSta.vue?vue&type=script&lang=js"
import style0 from "./PerformanceSta.vue?vue&type=style&index=0&id=1c05d84c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c05d84c",
  null
  
)

export default component.exports